// contexts/produtos/MarcaContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { fetchData, postData, putData, deleteData } from '../../services/Api';
import { useAlert } from '../geral/AlertContext';
import { useMessage } from '../geral/MessageContext';

const MarcaContext = createContext();

export const useMarca = () => useContext(MarcaContext);

export const MarcaProvider = ({ children }) => {
    const [marcas, setMarcas] = useState([]);
    const { showAlert } = useAlert(); // Access showMessage from AlertContext
    const { showMessage } = useMessage();

    useEffect(() => {
        const fetchDataFromAPI = async () => {
            try {
                const result = await fetchData('/Marca');
                setMarcas(result);                
            } catch (error) {
                console.error("Erro ao buscar marcas:", error);
            }
        };
        fetchDataFromAPI();
    }, []);

    const addMarca = async (marca) => {
        try {
            const result = await postData('/Marca', marca);
            setMarcas([...marcas, result]);
            showAlert('Marca adicionada com sucesso!');
        } catch (error) {
            console.error("Erro ao adicionar marca:", error);
            showMessage('Erro ao adicionar marca!\n'+error, 'danger');
        }
    };

    const updateMarca = async (marca) => {
        try {
            const result = await putData('/Marca', marca);
            setMarcas(marcas.map(m => m.id === result.id ? result : m));
            showAlert('Marca alterada com sucesso!');
        } catch (error) {
            console.error("Erro ao atualizar marca:", error);
            showMessage('Erro ao atualizar marca!\n'+error, 'danger');
        }
    };

    const deleteMarca = async (id) => {
        try {
            await deleteData('/Marca', { marcaId: id }); // Exclusão da marca no servidor
            setMarcas(marcas.filter(m => m.id !== id));
            showAlert('Marca excluída com sucesso!');
        } catch (error) {
            console.error("Erro ao excluir marca:", error);
            showMessage('Erro ao excluir marca!\n'+error, 'danger');
        }
    };

    return (
        <MarcaContext.Provider value={{ marcas, addMarca, updateMarca, deleteMarca }}>
            {children}
        </MarcaContext.Provider>
    );
};